export * from './common';
export * from './nx-common.enums';
export * from './nx-linked-list';

export enum BaseRoles {
  SUPER_ADMIN = 'SUPERADMIN',
  ADMIN       = 'ADMIN',
  GUEST       = 'GUEST'
}